import React from 'react'

const LogoHeader = (props) => {
    return (
        <div data-testid='logoHeader' className='authentication-logo-header' />
    )
}
export default LogoHeader
